export const toggleDrawer = () => {
    if(!document.querySelector('#drawer').classList.contains('drawer-close')){
        document.querySelector('#drawer').classList.add('drawer-close')
      } else {
        document.querySelector('#drawer').classList.remove('drawer-close')
      }
}